import { BrowserRouter as Router } from "react-router-dom";
import { PublicAppRouter } from "@/Router/PublicAppRouter";

const PublicApp = () => (
    <Router
        future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }}
    >
        <PublicAppRouter />
    </Router>
);

export default PublicApp;
